import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../baseQuery";

export const locationsApi = createApi({
  reducerPath: "locationsApi",
  baseQuery,
  tagTypes: [],
  keepUnusedDataFor: 60,
  endpoints: (builder) => ({
    getLocations: builder.query({
      query: () => "locations",
    }),
    register: builder.mutation({
      query: (form) => ({
        url: "locations",
        method: "POST",
        body: form,
      }),
    }),
    update: builder.mutation({
      query: ({ id, form }) => ({
        url: `locations/${id}`,
        method: "PUT",
        body: form,
      }),
    }),
  }),
});

export const { useGetLocationsQuery, useRegisterMutation, useUpdateMutation } =
  locationsApi;
